import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAreaProyecto, modifyAreaProyecto, fetchAreasProyecto } from '../../reducers/areaProyecto_slice';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2';
import { Alert, Col, Row } from 'react-bootstrap';
import ActionButton from '../UI/Buttons/ActionButton';

const initialState = {
    nombre: ""
}

const AreaProyectoForm = ({ currentAreaProyecto, showModal, handleClose }) => {
    const [datos, setDatos] = useState(initialState);
    const [error, setError] = useState('');
    const [isModified, setIsModified] = useState(false);

    const dispatch = useDispatch();
    const requestStatus = useSelector(state => state.areaProyecto.statusSend);
    const errorInRequest = useSelector(state => state.areaProyecto.error);

    useEffect(() => {
        if (currentAreaProyecto) {
            setDatos(currentAreaProyecto);
            setIsModified(false);
        } else {
            resetForm();
        }
    }, [currentAreaProyecto]);

    const handleSubmit = e => {
        e.preventDefault();

        if (isModified) {
            setError('');

            if (currentAreaProyecto) {
                dispatch(modifyAreaProyecto({ id: currentAreaProyecto.id, area: datos })).then(response => {
                    if (response.error || response.payload.error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.payload.error || response.error.message || 'Error al actualizar el rubro de proyecto.',
                        });
                    } else {
                        handleClose();
                        resetForm();
                        dispatch(fetchAreasProyecto());
                    }
                });
            } else {
                dispatch(addAreaProyecto(datos)).then(response => {
                    if (response.error || response.payload.error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.payload.error || response.error.message || 'Error al crear el rubro de proyecto.',
                        });
                    } else {
                        handleClose();
                        resetForm();
                        dispatch(fetchAreasProyecto());
                    }
                });
            }
        } else {
            handleClose();
            resetForm();
        }
    };

    const resetForm = () => {
        setDatos(initialState);
        setError('');
        setIsModified(false);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setDatos((prevDatos) => ({ ...prevDatos, [name]: value }));
        setIsModified(true);
    }

    let title = currentAreaProyecto ? "Editar Rubro" : "Nuevo Rubro";
    let headerColor = currentAreaProyecto ? '#255957' : '#254159';
    let buttonText = requestStatus !== "sending" ? (currentAreaProyecto ? 'Actualizar' : 'Crear') : "Enviando...";

    return (
        <Modal show={showModal} onHide={() => { handleClose(); resetForm(); }} backdrop="static" keyboard={false} size="lg">
            <Modal.Header closeButton style={{ backgroundColor: headerColor, color: 'white' }}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <Alert variant="danger">
                        {error}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row xs={1}>
                        <Col className='col-form'>
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                name="nombre"
                                value={datos.nombre}
                                onChange={handleInputChange}
                                required
                            />
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-between mt-5">
                        <Button variant="outline-dark" onClick={() => { handleClose(); resetForm(); }}>
                            Cancelar
                        </Button>
                        <ActionButton outline>
                            {buttonText}
                        </ActionButton>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AreaProyectoForm;
